import { render } from "./MemoryCard.vue?vue&type=template&id=526f4133"
import script from "./MemoryCard.vue?vue&type=script&lang=js"
export * from "./MemoryCard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe-registry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__